import { gql } from '@apollo/client';

export const CURRENT_LOCATION_ZIP_QUERY = gql`
  query CurrentLocationZip($data: CurrentLocationZipRequestInput!) {
    currentLocationZipRequest(data: $data) {
      zip
    }
  }
`;
